import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createFeature, createReducer, on } from '@ngrx/store';
import { HistoryEntry } from '@models';
import { HistoryEntriesActions } from './history-entries.actions';

interface HistoryEntriesState extends EntityState<HistoryEntry> {
  loading: boolean;
  error: string | null;
}

export const historyEntriesAdapter = createEntityAdapter<HistoryEntry>({ selectId: (e) => e.id ?? '' });

const initialHistoryEntriesState: HistoryEntriesState = historyEntriesAdapter.getInitialState({
  loading: false,
  error: null,
});

export const historyEntriesFeature = createFeature({
  name: 'historyEntries',
  reducer: createReducer(
    initialHistoryEntriesState,
    on(HistoryEntriesActions.loadScope, (state): HistoryEntriesState => ({ ...state, loading: true, error: null })),
    on(HistoryEntriesActions.loadScopeSucceeded, (state, { entries }): HistoryEntriesState =>
      historyEntriesAdapter.upsertMany(entries, { ...state, loading: false })
    ),
    on(HistoryEntriesActions.loadScopeFailed, (state, { error }): HistoryEntriesState => ({
      ...state,
      loading: false,
      error,
    })),
    on(HistoryEntriesActions.entrySaved, (state, { entry }): HistoryEntriesState =>
      historyEntriesAdapter.upsertOne(entry, state)
    ),
    on(HistoryEntriesActions.addEntryFailed, (state, { error }): HistoryEntriesState => ({ ...state, error }))
  ),
});
